var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stepComponent)?_c(_vm.stepComponent,{tag:"component",attrs:{"align-center":_vm.step == 2},on:{"next":_vm.toNextStep,"back":_vm.toBeforeStep}}):_c('pre',[_vm._v("Что-то пошло не так")])}
var staticRenderFns = []

export { render, staticRenderFns }